import React from "react";
import { func } from "prop-types";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { HERO_CONTENT, INTRO_TEXT } from "../partnered-data";
import "./hero-section.m.css";

export const HeroSection = ({ onPartnerFormOpen }) => {
  const heroImage = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "static_pages_images", "patnered_engagement"])
  );

  return (
    <>
      {/* HERO */}
      <section
        styleName="hero-section"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div styleName="centered">
          <div styleName="section-content">
            <p styleName="hero-label">{HERO_CONTENT.label}</p>
            <h1 styleName="hero-headline">{HERO_CONTENT.headline}</h1>
          </div>
        </div>
      </section>

      {/* HERO MOBILE BOX */}
      <div styleName="hero-mobile-box">
        <div styleName="centered">
          <div styleName="section-content">
            <h1 styleName="hero-headline">{HERO_CONTENT.headline}</h1>
          </div>
        </div>
      </div>

      {/* INTRO */}
      <section styleName="intro-section">
        <div styleName="centered">
          <div styleName="section-content">
            <p styleName="intro-text">
              <span styleName="highlight-text">{INTRO_TEXT.highlight}</span>{" "}
              {INTRO_TEXT.text}
            </p>
            <button
              styleName="hero-button"
              onClick={() => onPartnerFormOpen("Partner with us")}
            >
              {HERO_CONTENT.cta}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

HeroSection.propTypes = {
  onPartnerFormOpen: func.isRequired,
};
